import { useQuery } from "@tanstack/react-query";
import { oldBaseApi } from "@shared/api";
import { FeaturesListResponse, FlagKey, parseFeaturesFlags } from "../../types/features-list";

// Локальный оверрайд оптимизированного титульного листа (всегда перекрывает ответ API).
const MOCK_OPTIMIZED_TITLE_PAGE_ENABLED = "false";

// Локальный оверрайд флоу версионирования ОЖР (всегда перекрывает ответ API).
// "true" — версии журнала/титульного листа, заявки на изменение, OJR-панель формирования.
// "false" — скрывает версии, amendments и панель OJR, остаётся базовый просмотр журналов.
const MOCK_OJR_FORMATION_FLOW_ENABLED_V1 = "true";

// Локальный оверрайд раздела «Реестр актов» (всегда перекрывает ответ API).
// "true" — пункт «Реестр актов» в навигации проекта и страница records-register.
// "false" — скрывает пункт меню и редиректит со страницы реестра на 404.
const MOCK_ACTS_REGISTRY_ENABLED = "false";

// Локальный оверрайд «Настройки интеграции» в надзорном деле.
// "true" — пункт в меню надзорного дела и страница integration-settings.
// "false" — скрывает пункт меню и редиректит со страницы на 404.
const MOCK_SUPERVISION_INTEGRATION_SETTINGS_ENABLED = "true";

export const useFeaturesListQuery = () => {
  return useQuery({
    queryKey: ["features", "list"],
    queryFn: async () => {
      const response = await oldBaseApi.get<FeaturesListResponse>("/information-service/api/v1/ft");
      return {
        ...response.data,
        optimizedTitlePageEnabled: String(MOCK_OPTIMIZED_TITLE_PAGE_ENABLED),
        actsRegistryEnabled: String(MOCK_ACTS_REGISTRY_ENABLED),
        ojrFormationFlowEnabledV1: String(MOCK_OJR_FORMATION_FLOW_ENABLED_V1),
        supervisionIntegrationSettingsEnabled: String(
          response.data.supervisionIntegrationSettingsEnabled ??
            MOCK_SUPERVISION_INTEGRATION_SETTINGS_ENABLED,
        ),
      };
    },
  });
};

export const useFlags = (featureType?: FlagKey) => {
  const query = useFeaturesListQuery();
  const data = query.data ? parseFeaturesFlags(query.data) : undefined;

  if (featureType === "ojrFormationFlowEnabledV1") {
    return MOCK_OJR_FORMATION_FLOW_ENABLED_V1 === "true";
  }

  if (featureType) {
    return data ? data[featureType] : false;
  }
};
